export default "__VITE_ASSET__BOWKIhN___"